import '@vaadin/number-field';
// eslint-disable-next-line no-duplicate-imports
import type {
    NumberFieldValueChangedEvent,
    NumberField as VaadinNumberField,
} from '@vaadin/number-field';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { createRef, ref } from 'lit/directives/ref.js';
import { TmValueChanged } from './forms';
import { TmInputFieldBase } from './tm-input-field.base';

export const tagName = 'tm-number-field';

export type TmNumberFieldChanged = TmValueChanged<number>;

@customElement(tagName)
export class TmNumberField extends TmInputFieldBase<number> {
    @property({ type: Number })
    public min?: number;

    @property({ type: Number })
    public max?: number;

    private readonly numberFieldRef = createRef<VaadinNumberField>();

    protected validate() {
        return typeof this.value === 'number' && !Number.isNaN(this.value);
    }

    protected render() {
        return html`
            <vaadin-number-field
                ${ref(this.numberFieldRef)}
                @value-changed=${(e: NumberFieldValueChangedEvent) => {
                    const { value } = e.detail;
                    this.changeValue(parseInt(value, 10));
                }}
                class="w-full"
                label=${this.label}
                value=${this.initial?.toString() || ''}
                placeholder=${ifDefined(this.placeholder)}
                .min=${this.min}
                .max=${this.max}
                ?required=${this.required}
                ?readonly=${this.readonly}
                ?disabled=${this.disabled}
            >
            </vaadin-number-field>
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: TmNumberField;
    }
}
